// Cart drawer "Complete your order" recommendations + mobile sticky add-to-cart.

if (!customElements.get('rao-cart-recs')) {
  customElements.define(
    'rao-cart-recs',
    class RaoCartRecs extends HTMLElement {
      connectedCallback() {
        const productId = this.dataset.productId;
        if (!productId) return;
        const exclude = (this.dataset.exclude || '').split(',').map(Number);
        const url = `${window.Shopify.routes.root}recommendations/products.json?product_id=${productId}&limit=6&intent=related`;
        fetch(url)
          .then((r) => r.json())
          .then((data) => this.render((data.products || []).filter((p) => !exclude.includes(p.id) && p.available).slice(0, 3)))
          .catch(() => {});
      }

      render(products) {
        if (!products.length) return;
        const money = (cents) => 'Rs. ' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        const list = this.querySelector('.rao-recs__list');
        list.innerHTML = products
          .map((p) => {
            const v = p.variants.find((x) => x.available) || p.variants[0];
            const img = p.featured_image ? `${p.featured_image}${p.featured_image.includes('?') ? '&' : '?'}width=120` : '';
            return `<li class="rao-recs__item">
              <a href="${p.url}" class="rao-recs__img">${img ? `<img src="${img}" alt="" width="60" height="60" loading="lazy">` : ''}</a>
              <div class="rao-recs__info"><a href="${p.url}" class="rao-recs__name">${p.title}</a><span class="rao-recs__price">${money(v.price)}</span></div>
              <button type="button" class="rao-recs__add" data-variant-id="${v.id}">+ Add</button>
            </li>`;
          })
          .join('');
        list.querySelectorAll('.rao-recs__add').forEach((btn) => btn.addEventListener('click', () => this.add(btn)));
        this.hidden = false;
      }

      add(btn) {
        btn.disabled = true;
        btn.textContent = 'Adding…';
        const drawer = document.querySelector('cart-drawer');
        fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: Number(btn.dataset.variantId), quantity: 1 }],
            sections: drawer ? drawer.getSectionsToRender().map((s) => s.id) : [],
            sections_url: window.location.pathname,
          }),
        })
          .then((r) => r.json())
          .then((state) => {
            if (drawer && state.sections) {
              drawer.renderContents({ ...state, id: state.items && state.items[0] ? state.items[0].id : null });
            } else {
              window.location.reload();
            }
          })
          .catch(() => window.location.reload());
      }
    }
  );
}

(function stickyAddToCart() {
  const bar = document.querySelector('.rao-sticky-atc');
  if (!bar) return;
  const mainBtn = document.querySelector('[id^="ProductSubmitButton-"]');
  if (!mainBtn) return;

  const priceEl = bar.querySelector('.rao-sticky-atc__price');
  const btn = bar.querySelector('.rao-sticky-atc__btn');
  const syncPrice = () => {
    const current = document.querySelector('[id^="price-"] .price-item--sale, [id^="price-"] .price-item--regular');
    if (current && priceEl) priceEl.textContent = current.textContent.trim();
    btn.disabled = mainBtn.disabled;
  };

  btn.addEventListener('click', () => {
    syncPrice();
    if (!mainBtn.disabled) mainBtn.click();
  });

  // Animated ancestors (scroll-trigger transforms) break position: fixed, so hoist to <body>.
  document.body.appendChild(bar);

  let ticking = false;
  const update = () => {
    ticking = false;
    const show = mainBtn.getBoundingClientRect().bottom < 0;
    if (show === bar.classList.contains('is-visible')) return;
    syncPrice();
    bar.classList.toggle('is-visible', show);
    document.body.classList.toggle('rao-sticky-atc-on', show);
  };
  window.addEventListener(
    'scroll',
    () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    },
    { passive: true }
  );
  update();
})();
